var map = {
	"./artwork/hero-404.svg": "2ac9",
	"./artwork/hero-about.svg": "2184",
	"./artwork/hero-contact.svg": "2a26",
	"./artwork/hero-home.svg": "4909",
	"./artwork/hero-project.svg": "e982",
	"./bg-header.png": "d41d",
	"./logo-dark.svg": "2d66",
	"./logo-light.svg": "e91d",
	"./profile.jpg": "4b94",
	"./project-1/project-1.png": "a114",
	"./project-1/screen-1.jpg": "bc93",
	"./project-1/screen-2.jpg": "0952",
	"./project-10/project-10.png": "b758",
	"./project-10/screen-1.jpg": "e0b8",
	"./project-10/screen-2.jpg": "0338",
	"./project-2/project-2.png": "0e01",
	"./project-2/screen-1.jpg": "43b2",
	"./project-2/screen-2.jpg": "685c",
	"./project-3/project-3.png": "7817",
	"./project-3/screen-1.jpg": "21df",
	"./project-3/screen-2.jpg": "ccf5",
	"./project-4/project-4.png": "343f",
	"./project-4/screen-1.jpg": "c1ec",
	"./project-4/screen-2.jpg": "489a",
	"./project-5/project-5.png": "c747",
	"./project-5/screen-1.jpg": "1a8f",
	"./project-5/screen-2.jpg": "9ebc",
	"./project-6/project-6.png": "7a57",
	"./project-6/screen-1.jpg": "1444",
	"./project-6/screen-2.jpg": "18fb",
	"./project-7/project-7.png": "38ae",
	"./project-7/screen-1.jpg": "b045",
	"./project-7/screen-2.jpg": "97b2",
	"./project-8/project-8.png": "13e5",
	"./project-8/screen-1.jpg": "21f7",
	"./project-8/screen-2.jpg": "d1c2",
	"./project-9/project-9.png": "201d",
	"./project-9/screen-1.jpg": "9fb0",
	"./project-9/screen-2.jpg": "87eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";